<div class="mobile-register-sign-in position-fixed-bottom hide-for-large">
  <ul class="no-bullet flex-container align-center align-middle">
    <li class="align-center">
      <button type="button" (click)="registerButtonClicked()" class="button button--icon-on-left clear underline width-100">
        <svg class="icon icon--register icon--material" viewBox="0 0 24 24" style="width: 24px; height: 24px">
          <use xlink:href="#icon-register" href="#icon-register"></use>
        </svg>
        <span>{{ translate("Register") | async }}</span>
      </button>
    </li>
    <li class="align-center">
      <button type="button" (click)="signInButtonClicked()" class="button button--icon-on-left clear underline width-100">
        <svg class="icon icon--sign-in icon--material" viewBox="0 0 24 24" style="width: 24px; height: 24px">
          <use xlink:href="#icon-sign-in" href="#icon-sign-in"></use>
        </svg>
        <span>{{ translate("Sign in") | async }}</span>
      </button>
    </li>
  </ul>
</div>
